import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../state/app.state';
import { issueTypesLabelMap, projectDetails } from '../../../../../../../core/projects.selectors';
import { takeUntil, map } from 'rxjs/operators';
import { isIssueStageStatus } from '../../../../../../../../../shared/helpers/issue-workflow';

@Component({
    selector: 'app-issue-summary',
    templateUrl: './issue-summary.component.html',
    styleUrls: ['./issue-summary.component.scss'],
    standalone: false
})
export class IssueSummaryComponent implements OnInit, OnDestroy {
  /** Lets a superseded link's badge add "· map now rev M" on the read-only card. */
  readonly projectId$ = inject(Store).select(projectDetails).pipe(map(project => project?.id ?? null));
  @Input() issue: any;
  issueTypesLabelMap: any = {
    standard: 'Standard',
    environment: 'Environment',
    safety: 'Safety',
    'as-built': 'As built',
  };
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.store.select(issueTypesLabelMap)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        if (Object.keys(d).length > 0) {
          this.issueTypesLabelMap = d;
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  /**
   * The plain open / closed pill stands unless the status is a
   * contractor-workflow stage, which app-issue-stage-chip shows instead: one
   * status pill either way.
   */
  get isStageStatus(): boolean {
    return isIssueStageStatus(this.issue?.status);
  }
}
